/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { StatusWorkflowDtoUpdate } from '../../models/status-workflow-dto-update';
import { StatusWorkflowItem } from '../../models/status-workflow-item';

export interface StatusWorkflowControllerUpdateStatusWorkflow$Params {
  id: number;
      body: StatusWorkflowDtoUpdate
}

export function statusWorkflowControllerUpdateStatusWorkflow(http: HttpClient, rootUrl: string, params: StatusWorkflowControllerUpdateStatusWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowItem;
}>> {
  const rb = new RequestBuilder(rootUrl, statusWorkflowControllerUpdateStatusWorkflow.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: StatusWorkflowItem;
      }>;
    })
  );
}

statusWorkflowControllerUpdateStatusWorkflow.PATH = '/status-workflow/{id}';
